import { Component, Inject } from '@angular/core';

import { Injectable } from '@angular/core';

import { Router, NavigationEnd, NavigationError } from '@angular/router';
// xplat
import { AppBaseComponent } from '@moduurnv2/web';
import { SharedService } from '@moduurnv2/libs-orderingapp';
import { Select ,Store} from '@ngxs/store';
import {
  WhitelabelState,
  Whitelabel,
  SetSelectedLocation,
  FetchLocationList,
  LocationState,
  Location,
  SetSelectedDelivery,
  FetchDeliveryList,
  DeliveryState,
  Delivery,
  SetSelectedTable,
  SetLocationAccess,
  ResetCustomerPerTable,
  ClearLoginDetails,
  ClearCart,
  ClearMenuItem,
  ClearMenuList, 
  FetchVenues,
  ResetInProgressStatus,
  FetchInProgressStatus,
  VenueManagementState,
} from '@moduurnv2/libs-orderingapp/src/core';
import { Observable,Subscription } from 'rxjs';
import { MessagingService } from '@moduurnv2/web/core';
import { AnalyticsHandler } from '@moduurnv2/core/services';
import { PWAService } from '@moduurnv2/core/services';

import { HttpClient } from '@angular/common/http';
import { environment } from '@moduurnv2/libs-orderingapp/src/core';
import * as CryptoJS from 'crypto-js';
import { Config } from './../config';
@Component({
  selector: 'wj-moduurnv2-root',
  templateUrl: './wj-app.component.html',
  styleUrls: ['./wj-app.component.scss'],
})
@Injectable({
  providedIn: PWAService,
})
export class WJAppComponent extends AppBaseComponent {
  @Select(WhitelabelState.getWhitelabel) whitelabel$: Observable<Whitelabel>;
  @Select(LocationState.getLocationsList) locationsList$: Observable<
    Location[]
  >;
  @Select(DeliveryState.getDeliveryList) deliveryList$: Observable<Delivery[]>;
  isMobileView: boolean;
  locationListSubscription:Subscription;
  deliveryListSubscription:Subscription;
  initialLoad:boolean = false;
  cipher = Config.cipher;
  guestDetails: any;
  selectedLocation: any;
  selectedTable: any;

  constructor(
    private router: Router,
    private http: HttpClient,
    private analyticsHandler: AnalyticsHandler,
    public messagingService: MessagingService,
    private shared: SharedService,
    private store:Store
  ) {
    super();
    this.whitelabel$.subscribe((response) => {
    });
    
    
    if(Config.appVersion)
    console.log(`You are using v ${Config.appVersion}`)
  }
  ngOnInit() {
    this.isMobileView = this.shared.isMobileScreen();
    this.messagingService.reciveNotificationIfEnabled();
    this.guestDetails = JSON.parse(localStorage.getItem('guest'));
    this.getInitialDataForLoungeDelivery();
  }

  ngOnDestroy(){
    if(this.locationListSubscription)
    this.locationListSubscription.unsubscribe();
    if(this.deliveryListSubscription)
    this.deliveryListSubscription.unsubscribe();
  }

  getInitialDataForLoungeDelivery() {
      this.initialLoad = true;
      const url = window.location.href;
      let vars = {};
      let queryParams = url.split("?")[1];
      //console.log(queryParams)
      if(queryParams){
        let queryParam = queryParams.split('&');
        let params;
        let decryptedData;
        let b64String;
        for (var i = 0; i < queryParam.length; i++) {
          params=queryParam[i].split("=");
          vars[params[0]] = params[1];
          if(vars['table'] && vars['table'].length > 10){ //this is the backwards compaitibility, if it's short its old. max length pickup.
            b64String = decodeURIComponent(params[1]);
            var bytes  = CryptoJS.AES.decrypt(b64String, Config.organizationId + this.cipher);
            decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            vars['table'] = decryptedData['tableNumber']
          }
        }

        if(vars && vars['table']){
          let locationId = window.location.pathname.split('/')[2];

          //does this person already have a session started?  Should we just let them continue?
          this.selectedTable = this.store.selectSnapshot(
            VenueManagementState.getSelectedLoungeTable
          );
          this.selectedLocation = this.store.selectSnapshot(LocationState.getSelectedLocation);


          this.store.dispatch(new FetchLocationList());
          this.locationListSubscription = this.locationsList$.subscribe((locations) => {

             if(locations){
               if(locations.length>0){
                if (this.selectedTable?.name != vars['table'] || this.selectedLocation?._id != locationId) {
                  this.store.dispatch(new ResetCustomerPerTable(''));
                  this.store.dispatch(new ClearCart());
                  this.store.dispatch(new ClearMenuItem());
                  this.store.dispatch(new ClearMenuList());
                }
                //this.store.dispatch(new ResetInProgressStatus());
                 let selLocation = locations.find(loc=> loc._id == locationId);

                 if(selLocation && selLocation['deliveryTypes']){

                  let requiredDeliveryType = vars['table']== 'pickup' ? 'DELIVERYTYPE02' : 'DELIVERYTYPE08'

                  selLocation['deliveryTypes'].map((delivery) => {
                    if (delivery.textCode == requiredDeliveryType && this.initialLoad) {
                      this.store.dispatch(new SetSelectedLocation(locationId));
                      this.store.dispatch(new ClearLoginDetails());
                      this.store.dispatch(new FetchDeliveryList());
                      this.store.dispatch(new SetLocationAccess(false));
                    this.deliveryListSubscription = this.deliveryList$.subscribe((deliveries)=>{
                        if(deliveries){
                          if (delivery.textCode == requiredDeliveryType && this.initialLoad) {
                          this.store.dispatch(new SetSelectedDelivery(delivery.textCode));
                          this.store.dispatch(new FetchVenues({locationId: locationId}));
                          this.initialLoad = false;

                          this.store.dispatch(new SetSelectedTable({name:vars['table']}));
                          if (vars['table'] != 'pickup') {
                            // TODO table number validity check 
                            this.store.dispatch(new FetchInProgressStatus({locationId: locationId, venue:vars['table']}));
                          } else {
                            if (this.guestDetails?.phone?.length > 3) { //arbitrary phone number length, just something, so we don't query nothing.
                              this.store.dispatch(new FetchInProgressStatus({locationId: locationId, phone:this.guestDetails.phone}));
                            } else {
                              this.store.dispatch(new ResetInProgressStatus());
                            }
                          }
                          this.router.navigate([`locations/${locationId}/home`],{ queryParams: { 'tableNumber': vars['table']}})

                          }
                        }
                      })
                    }
                  });
                 }
               }
             }
          });
        }
      }
  }
}
